export default __webpack_public_path__ + "static/media/reports-card-background.5fb96bf3.png";